<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-4 border-0">
              <div class="flex flex-wrap items-center gap-3">
                <div class="relative w-full max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">素材库</h3>
                  <p class="mt-1 text-sm text-blueGray-500">
                    上传图片并查看当前素材库中已经上传的图片。
                  </p>
                </div>
                <div class="relative w-full max-w-full flex-grow flex-1 text-right">
                  <el-upload
                    name="file"
                    class="upload-picture-entry"
                    drag
                    :action="uploadImgUrl"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :data="uploadData"
                    :before-upload="beforeImgUpload"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                  >
                    <div class="upload-picture-entry-content">
                      <div class="upload-picture-entry-title">拖拽图片到这里，或点击上传</div>
                      <div class="upload-picture-entry-desc">上传后会自动打开配置弹窗</div>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>

            <div class="block w-full px-6 pb-6">
              <div v-loading="loading">
                <el-empty v-if="!loading && list.length === 0" description="暂未上传素材" />

                <div v-else class="library-grid">
                  <el-card
                    v-for="item in list"
                    :key="item._id || item.url"
                    :body-style="{ padding: '0px' }"
                    class="library-card"
                  >
                    <div class="library-preview-wrap">
                      <img :src="getDisplayPictureUrl(item)" class="library-preview" />
                    </div>
                    <div class="library-card-body">
                      <div class="library-file-name" :title="item.filename || '未命名图片'">
                        {{ item.filename || "未命名图片" }}
                      </div>
                      <div class="library-meta">尺寸：{{ formatDimensions(item) }}</div>
                      <div class="library-meta">大小：{{ formatFileSize(item.fsize) }}</div>
                      <div class="library-meta">上传人：{{ item.uploader_name || "-" }}</div>
                      <div class="library-meta">时间：{{ formatTime(item.ctime) }}</div>
                      <div class="library-actions">
                        <el-button size="small" @click="copyUrl(item)">复制链接</el-button>
                        <el-button size="small" type="primary" @click="previewImage(item)">
                          预览
                        </el-button>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>

              <el-pagination
                class="mt-6 text-right"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[20, 50, 100]"
                :current-page="currentPage"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-model="previewVisible" title="图片预览" width="720px">
      <div class="library-dialog-body">
        <img v-if="previewUrl" :src="previewUrl" class="library-dialog-image" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
const MATERIAL_LIBRARY_BIZ = "lib";

export default {
  name: "MaterialLibrary",
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      list: [],
      previewVisible: false,
      previewUrl: "",
      uploadImgUrl: this.$uploadImageUrl,
      uploadHeaders: this.$getUploadHeaders(),
      uploadData: {
        biz: MATERIAL_LIBRARY_BIZ,
        biz_type: MATERIAL_LIBRARY_BIZ,
      },
    };
  },
  mounted() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.loading = true;
      this.$$getUploadedList(
        {
          page: this.currentPage,
          page_size: this.pageSize,
          biz: MATERIAL_LIBRARY_BIZ,
          biz_type: MATERIAL_LIBRARY_BIZ,
        },
        (res) => {
          this.loading = false;
          if (res?.sta !== 0) {
            this.$message.error(res?.msg || "请求素材列表失败!");
            return;
          }

          this.list = Array.isArray(res?.data?.list) ? res.data.list : [];
          this.total = res?.data?.total || 0;
        },
        () => {
          this.loading = false;
          this.$message.error("请求素材列表失败!");
        }
      );
    },
    refreshData() {
      this.currentPage = 1;
      this.queryData();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryData();
    },
    beforeImgUpload(file) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        this.$message.error("只能上传图片文件!");
        return false;
      }

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleUploadSuccess(res) {
      if (res?.sta !== 0) {
        this.$message.error(res?.msg || "上传图片失败!");
        return;
      }

      this.$message.success("上传图片成功!");
      this.refreshData();
    },
    handleUploadError() {
      this.$message.error("上传图片失败!");
    },
    getOriginalPictureUrl(item) {
      return item.url || item.pic_url || "";
    },
    getDisplayPictureUrl(item) {
      const url = this.getOriginalPictureUrl(item);
      if (!url) {
        return "";
      }

      const lowerUrl = url.toLowerCase().split("?")[0];
      if (lowerUrl.endsWith(".svg")) {
        return url;
      }
      return url;

      // const suffix = "imageMogr2/thumbnail/240x";
      // return `${url}${url.includes("?") ? "&" : "?"}${suffix}`;
    },
    previewImage(item) {
      this.previewUrl = this.getDisplayPictureUrl(item);
      this.previewVisible = true;
    },
    async copyUrl(item) {
      const url = this.getOriginalPictureUrl(item);
      if (!url) {
        this.$message.error("图片链接不存在");
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        this.$message.success("复制成功");
      } catch (error) {
        this.$message.error("复制失败，请手动复制");
      }
    },
    formatDimensions(item) {
      const width = item?.width || 0;
      const height = item?.height || 0;
      return width && height ? `${width} x ${height}` : "-";
    },
    formatFileSize(size) {
      const value = Number(size || 0);
      if (!value) {
        return "-";
      }

      if (value < 1024) {
        return `${value} B`;
      }

      if (value < 1024 * 1024) {
        return `${(value / 1024).toFixed(1)} KB`;
      }

      return `${(value / 1024 / 1024).toFixed(2)} MB`;
    },
    formatTime(timestamp) {
      if (!timestamp) {
        return "-";
      }

      const date = new Date(Number(timestamp) * 1000);
      if (Number.isNaN(date.getTime())) {
        return "-";
      }

      const pad = (value) => String(value).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
  },
};
</script>

<style scoped>
.upload-picture-entry {
  width: 260px;
  margin-left: auto;
}

.upload-picture-entry :deep(.el-upload) {
  width: 100%;
}

.upload-picture-entry :deep(.el-upload-dragger) {
  width: 100%;
  min-height: 64px;
  padding: 0;
  border-radius: 10px;
  border-color: #86efac;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-picture-entry-content {
  min-height: 62px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
}

.upload-picture-entry-title {
  font-size: 13px;
  line-height: 1.2;
  font-weight: 600;
  color: #047857;
}

.upload-picture-entry-desc {
  font-size: 11px;
  line-height: 1.2;
  color: #64748b;
}

.library-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
}

.library-card {
  overflow: hidden;
  border-radius: 16px;
}

.library-preview-wrap {
  height: 210px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.library-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.library-card-body {
  padding: 16px;
}

.library-file-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 10px;
  word-break: break-all;
}

.library-meta {
  font-size: 12px;
  color: #64748b;
  line-height: 1.8;
}

.library-actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}

.library-dialog-body {
  display: flex;
  justify-content: center;
}

.library-dialog-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>
